export const hasVisibleText = (text) => Boolean(text.replace(/[\n\r\s]/g, '').length);
//# sourceMappingURL=text.js.map